import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("purposeful_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const ASSETS = {
    logo: "/assets/logo.jpg",
    bookCover: "/assets/book-cover.png",
    author: "/assets/author.png",
    network:
        "https://images.pexels.com/photos/7580648/pexels-photo-7580648.jpeg?auto=compress&cs=tinysrgb&w=1400",
    office: "https://images.pexels.com/photos/5324900/pexels-photo-5324900.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const LINKEDIN_URL = "https://www.linkedin.com/in/buildwithbhat/";
